"use client";

import { c as _c } from "react/compiler-runtime";
import { Alert, Badge, Button, Modal, Progress, Rating, Stack, Text, Textarea, TextInput } from "@mantine/core";
import { Icon } from "@iconify/react";
import { alldayjs } from "@/lib/dayjs";
import { useEffect, useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import CheckoutLoginModal from "@/components/checkout/CheckoutLoginModal";
import { useCustomer } from "@/contexts/customerContext";
import { useProduct } from "@/hooks/useProduct";
import { notifications } from "@mantine/notifications";
import { useForm } from "@mantine/form";
const TITLE_MAX_LENGTH = 100;
const TEXT_MAX_LENGTH = 1000;
const MARKUP_PATTERN = /[<>]/;
export default function ReviewSection(t0) {
  const $ = _c(31);
  const {
    product
  } = t0;
  const handle = product?.handle;
  const {
    productReviews,
    refetchReviews
  } = useProduct(handle);
  const reviews = productReviews?.reviews || [];
  const {
    customer,
    isLoading: t1
  } = useCustomer();
  const isLoading = t1 === undefined ? false : t1;
  const existingReview = productReviews?.user_review || null;
  const [loginOpened, t2] = useDisclosure(false);
  const {
    open: openLogin,
    close: closeLogin
  } = t2;
  const [reviewOpened, t3] = useDisclosure(false);
  const {
    open: openReview,
    close: closeReview
  } = t3;
  let t4;
  if ($[0] !== customer || $[1] !== isLoading || $[2] !== openLogin || $[3] !== openReview) {
    t4 = function handleWriteReviewClick() {
      if (isLoading) {
        return;
      }
      if (!customer) {
        openLogin();
        return;
      }
      openReview();
    };
    $[0] = customer;
    $[1] = isLoading;
    $[2] = openLogin;
    $[3] = openReview;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleWriteReviewClick = t4;
  let t5;
  if ($[5] !== closeReview || $[6] !== refetchReviews) {
    t5 = function handleReviewSubmitted() {
      closeReview();
      refetchReviews?.();
    };
    $[5] = closeReview;
    $[6] = refetchReviews;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleReviewSubmitted = t5;
  const reviewButtonLabel = existingReview ? "Edit Your Review" : "Write a Review";
  const t6 = "rsid";
  const t7 = "py-4 bg-gray-50";
  const t8 = "max-w-7xl mx-auto";
  const t9 = `${product.title} `;
  let t10;
  if ($[8] !== t9) {
    t10 = <h2 className="text-xl lg:text-2xl mb-1"><span className="hidden">{t9}</span>Product Reviews</h2>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = reviews?.length > 0 && <div className="shadow p-2 bg-white rounded-md"><div className="flex flex-col lg:flex-row items-center justify-center gap-x-1 gap-y-3"><div className="text-center w-full lg:w-1/4"><Rating defaultValue={productReviews?.reviews_avg_rating?.toFixed(1) || 5} fractions={2} readOnly={true} mx="auto" size="lg" /><span className="ms-2 text-gray-700"> {productReviews?.reviews_avg_rating?.toFixed(1) || 5} out of 5</span><div>Based on {productReviews?.reviews_count ? `${productReviews?.reviews_count}` : "0"} reviews</div></div><div className="text-center w-full lg:w-1/2"><div className="flex flex-col gap-2 items-center"><div className="flex items-center gap-2"><Rating defaultValue={5} readOnly={true} /><Progress aria-label="5 Stars" value={productReviews?.stars5 * 100 / (productReviews?.reviews_count || 0)} color="green" miw={{
              base: 200,
              lg: 350
            }} /><div>{productReviews?.stars5 || 0}</div></div><div className="flex items-center gap-2"><Rating defaultValue={4} readOnly={true} /><Progress aria-label="4 Stars" value={productReviews?.stars4 * 100 / (productReviews?.reviews_count || 2)} color="lime" miw={{
              base: 200,
              lg: 350
            }} /><div>{productReviews?.stars4 || 0}</div></div><div className="flex items-center gap-2"><Rating defaultValue={3} readOnly={true} /><Progress aria-label="3 Stars" value={productReviews?.stars3 * 100 / (productReviews?.reviews_count || 2)} color="blue" miw={{
              base: 200,
              lg: 350
            }} /><div>{productReviews?.stars3 || 0}</div></div><div className="flex items-center gap-2"><Rating defaultValue={2} readOnly={true} /><Progress aria-label="2 Stars" value={productReviews?.stars2 * 100 / (productReviews?.reviews_count || 2)} color="yellow" miw={{
              base: 200,
              lg: 350
            }} /><div>{productReviews?.stars2 || 0}</div></div><div className="flex items-center gap-2"><Rating defaultValue={1} readOnly={true} /><Progress aria-label="1 Star" value={productReviews?.stars1 * 100 / (productReviews?.reviews_count || 2)} color="red" miw={{
              base: 200,
              lg: 350
            }} /><div>{productReviews?.stars1 || 0}</div></div></div></div><div className="text-center w-full lg:w-1/4"><Button onClick={handleWriteReviewClick} loading={isLoading}>{reviewButtonLabel}</Button>{existingReview && <div className="mt-1"><Badge color="blue" variant="light">Already reviewed</Badge></div>}</div></div></div>;
  const t12 = "grid grid-cols-1 lg:grid-cols-2 justify-center gap-2 mt-2";
  const t13 = reviews?.length > 0 ? reviews?.slice(0, 10)?.map((review, rdx) => {
    const isOwnReview = customer && review.customer_id === customer.customer_id;
    const reviewer = review?.customer;
    return <div className="bg-white rounded-md shadow p-2" key={rdx}><div className="flex items-center gap-1"><span className="font-bold me-2">Review</span><Rating defaultValue={review.rating} readOnly={true} /><span className="ms-2">{review.rating.toFixed(1)}</span>{isOwnReview && <Badge color="blue" variant="light" ml="auto">Your review</Badge>}</div><div className="font-heading text-base lg:text-xl">{review.review_title}</div><div>{review.review_text}</div><div className="flex gap-1 items-center justify-center lg:justify-end"><div className="font-heading">by: {reviewer.fname} {reviewer.lname}</div><div className="text-xs">{alldayjs(review.created_at).fromNow(true)} ago</div><Icon icon="material-icon-theme:verified" className="text-xl" /><Badge color="green.9" fw={400}> Verified</Badge></div></div>;
  }) : <div className="bg-white col-span-2 rounded-md shadow py-5 px-2 flex flex-col items-center gap-2"><Icon icon="mdi:star-plus-outline" className="text-gray-700" fontSize={48} /><div>No Reviews yet</div><div>{product?.title}? Help other shopping fans and be the first to review it</div><Button onClick={handleWriteReviewClick} loading={isLoading}>{reviewButtonLabel}</Button></div>;
  let t14;
  if ($[10] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[10] = t13;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== t10 || $[13] !== t11 || $[14] !== t14) {
    t15 = <div className={t8}>{t10}{t11}{t14}</div>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== closeLogin || $[17] !== customer || $[18] !== loginOpened) {
    t16 = !customer && <CheckoutLoginModal opened={loginOpened} onClose={closeLogin} />;
    $[16] = closeLogin;
    $[17] = customer;
    $[18] = loginOpened;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== closeReview || $[21] !== customer || $[22] !== existingReview || $[23] !== handleReviewSubmitted || $[24] !== product || $[25] !== reviewOpened) {
    t17 = <ReviewFormModal opened={reviewOpened} onClose={closeReview} product={product} customer={customer} existingReview={existingReview} onSubmitted={handleReviewSubmitted} />;
    $[20] = closeReview;
    $[21] = customer;
    $[22] = existingReview;
    $[23] = handleReviewSubmitted;
    $[24] = product;
    $[25] = reviewOpened;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t15 || $[28] !== t16 || $[29] !== t17) {
    t18 = <section id={t6} className={t7}>{t15}{t16}{t17}</section>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
}
function ReviewFormModal({
  opened,
  onClose,
  product,
  customer,
  existingReview,
  onSubmitted
}) {
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const reviewMessage = existingReview ? "Review Updated" : "Review Submitted";
  const form = useForm({
    mode: "controlled",
    initialValues: {
      rating: existingReview?.rating || 5,
      title: existingReview?.review_title || "",
      text: existingReview?.review_text || ""
    },
    validateInputOnChange: true,
    validate: {
      rating: value => value >= 1 && value <= 5 ? null : "Please select a rating",
      title: value => {
        const trimmed = value.trim();
        if (!trimmed) return "Review title is required";
        if (trimmed.length > TITLE_MAX_LENGTH) return `Title must be ${TITLE_MAX_LENGTH} characters or fewer`;
        if (MARKUP_PATTERN.test(value)) return "The characters < and > aren't allowed";
        return null;
      },
      text: value => {
        const trimmed = value.trim();
        if (!trimmed) return "Review text is required";
        if (trimmed.length > TEXT_MAX_LENGTH) return `Review must be ${TEXT_MAX_LENGTH} characters or fewer`;
        if (MARKUP_PATTERN.test(value)) return "The characters < and > aren't allowed";
        return null;
      }
    }
  });
  useEffect(() => {
    if (opened) {
      form.setValues({
        rating: existingReview?.rating || 5,
        title: existingReview?.review_title || "",
        text: existingReview?.review_text || ""
      });
      form.clearErrors();
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setError("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened, existingReview]);
  async function handleSubmit(values) {
    setError("");
    setSubmitting(true);
    try {
      const res = await fetch(`/api/products/${product.handle}/reviews`, {
        method: existingReview ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          product_id: product.product_id,
          rating: values.rating,
          review_title: values.title.trim(),
          review_text: values.text.trim(),
          customer_id: customer?.customer_id
        })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.message || "Something went wrong. Please try again.");
      }
      const data = await res.json();
      onSubmitted?.(data);
      onClose();
      notifications.show({
        title: 'Success',
        color: 'green',
        message: reviewMessage
      });
    } catch (err) {
      setError(err.message);
      notifications.show({
        title: 'Error',
        color: 'red',
        message: err.message
      });
    } finally {
      setSubmitting(false);
    }
  }
  return <Modal opened={opened} onClose={onClose} title={existingReview ? "Edit your review" : `Write a review - ${product.title}`} centered>
            <form onSubmit={form.onSubmit(handleSubmit)}>
                <Stack gap="sm">
                    {error && <Alert color="red">{error}</Alert>}
                    <div>
                        <Text size="sm" fw={500} mb={4}>
                            Your rating
                        </Text>
                        <Rating {...form.getInputProps('rating')} size="lg" />
                    </div>
                    <TextInput label="Review Title" placeholder={'e.g:Highly Recommended, fast delivery'} maxLength={TITLE_MAX_LENGTH} description={`${form.values.title.length}/${TITLE_MAX_LENGTH}`} required {...form.getInputProps('title')} />
                    <Textarea label="Review" minRows={4} placeholder={'What you think of it'} maxLength={TEXT_MAX_LENGTH} description={`${form.values.text.length}/${TEXT_MAX_LENGTH}`} required {...form.getInputProps('text')} />
                    <Button type="submit" loading={submitting} disabled={!form.isValid()} fullWidth mt="sm">
                        {existingReview ? "Update review" : "Submit review"}
                    </Button>
                    <div className={'text-xs opacity-70'}>
                        Reviews are moderated before publication. We only publish reviews from genuine customers and never edit ratings.
                    </div>
                </Stack>
            </form>
        </Modal>;
}